/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * instead, edit one of the `.graphql` files in this project and run
 * `pnpm nx run graphql:codegen `
 * for this file to be re-created
 */
import * as Types from '@main/graphql/types.admin.generated';

import type { TypedDocumentNode } from '@graphql-typed-document-node/core';
import * as ClientTypes from '@main/graphql/client-scalars';
import { api } from '@main/graphql/shared-api';
export type UpdatePlatformUsersMutationVariables = Types.Exact<{
  userIds: Array<Types.Scalars['uuid']['input']> | Types.Scalars['uuid']['input'];
  users_set_input: Types.Users_Set_Input;
}>;

export type UpdatePlatformUsersMutation = {
  __typename?: 'mutation_root';
  updateUsers?: { __typename?: 'users_mutation_response'; affected_rows: number } | null;
};

export const UpdatePlatformUsersDocument = `
    mutation UpdatePlatformUsers($userIds: [uuid!]!, $users_set_input: users_set_input!) {
  updateUsers(where: {id: {_in: $userIds}}, _set: $users_set_input) {
    affected_rows
  }
}
    ` as string &
  TypedDocumentNode<UpdatePlatformUsersMutation, UpdatePlatformUsersMutationVariables>;

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    UpdatePlatformUsers: build.mutation<
      UpdatePlatformUsersMutation,
      UpdatePlatformUsersMutationVariables
    >({
      query: (variables) => ({ document: UpdatePlatformUsersDocument, variables }),
    }),
  }),
});

export { injectedRtkApi as api };
export const { useUpdatePlatformUsersMutation } = injectedRtkApi;
